<template>
  <div>
    <div class="modal-form-coluna">
      <div>
        <h3>CNPJ <span>*</span></h3>
        <div class="cenario-cnpj">
          <CenarioInput
            tipo="texto"
            placeholder="Informe o CNPJ"
            mask="##.###.###/####-##"
            :model="form.cnpj"
            @update:model="update => calculaForm(update, 'cnpj')"
            nome="cnpj"
            :validaCampos="camposRequeridos"
            :exibeValidacao="exibeValidacao"
          />
          <BotaoPadrao
            arredondadoDireita
            tipo="icone"
            class="botao-padding"
            icone="search"
            :click="handleCnpj"
            cor="azul"
            padding="30"
            tamanho="15"
            :desabilita="form.cnpj.length != 18"
            :tooltip="form.cnpj.length != 18 ? 'Preencha o campo de CNPJ' : 'Buscar dados da Empresa'"
          />
        </div>
      </div>
      <div>
        <h3>NOME DA EMPRESA <span>*</span></h3>
        <div>
          <CenarioInput
            tipo="texto"
            placeholder="Informe o nome da empresa"
            :model="form.nome"
            @update:model="update => calculaForm(update, 'nome')"
            nome="nome"
            :validaCampos="camposRequeridos"
            :exibeValidacao="exibeValidacao"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "ModalEmpresaPrimeiraLinha",
  components: {
    BotaoPadrao,
    CenarioInput
  },
  props: {
    calculaForm: Function,
    form: Object,
    camposRequeridos: Object,
    handleCnpj: Function,
    exibeValidacao: Boolean
  },
  data() {
    return {
      cnpj: "",
      nome: ""
    };
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}

.cenario-cnpj {
  display: flex;
}
.modal-form-coluna {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 10px;
  margin-bottom: 10px;
}
</style>
